import { useState } from "react";

const stampStyle = {
  display: "inline-block",
  border: "2.5px solid rgba(30, 58, 120, 0.55)",
  borderRadius: "2px",
  opacity: 0.6,
  pointerEvents: "none",
  userSelect: "none",
  transform: "rotate(-8deg)",   // more dramatic tilt like real stamps
};

const innerStyle = {
  border: "1.5px solid rgba(30, 58, 120, 0.55)",
  margin: "4px",
  padding: "7px 14px 9px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "3px",
  minWidth: "195px",
};

const titleStyle = {
  fontSize: "12.5px",
  fontWeight: 700,
  letterSpacing: "0.09em",
  color: "rgba(30, 58, 120, 0.9)",
  textAlign: "center",
};

const dividerStyle = {
  width: "100%",
  height: "1.5px",
  background: "rgba(30, 58, 120, 0.5)",
  margin: "2px 0",
};

const dateRowStyle = {
  fontSize: "12px",
  color: "rgba(30, 58, 120, 0.9)",
  width: "100%",
  padding: "2px 0",
};

const footerStyle = {
  fontSize: "11.5px",
  fontWeight: 700,
  letterSpacing: "0.13em",
  color: "rgba(30, 58, 120, 0.9)",
  textAlign: "center",
};
function formatDate(date) {
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const d = date instanceof Date ? date : new Date(date);
  return `${String(d.getDate()).padStart(2, "0")} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

export default function ReceivedStamp({ date, style }) {
  const displayDate = date ? formatDate(date) : formatDate(new Date());

  return (
    <div style={{ ...stampStyle, ...style }}>
      <div style={innerStyle}>
        <div style={titleStyle}>ATLANTIC PACIFIC LINES</div>
        <div style={dividerStyle} />
        <div style={dateRowStyle}>
          <span style={{ fontWeight: 700, letterSpacing: "0.08em" }}>DATED : </span>
          {displayDate}
        </div>
        <div style={dividerStyle} />
        <div style={footerStyle}>RECEIVED FOR SHIPMENT</div>
      </div>
    </div>
  );
}